import React from "react";
import { number, func, bool } from "prop-types";
import { Dropdown, DropdownButton } from "react-bootstrap";

const EventExpirationByDays = ({
  eventExpirationDays,
  handleTestExpirationDropdown,
  fromSchedulingEventExpiration,
  fromExtendEventExpiration,
}) => {
  // create array 1 to 14 for expiration days.
  // this logic allows us to change the number of days whenever we need to.
  const expirationDayCountArr = Array.from(Array(14).keys(), (n) => n + 1);
  const expirationDateDropdownItems = expirationDayCountArr.map(
    (expirationDay) => (
      <Dropdown.Item eventKey={expirationDay} key={expirationDay}>
        {expirationDay}
      </Dropdown.Item>
    )
  );

  if (fromExtendEventExpiration) {
    return (
      <div className="mt-2 ml-4">
        Extend event expiration by
        <DropdownButton
          className="d-inline-block ml-1 mr-1"
          variant="outline-secondary"
          title={eventExpirationDays || ""}
          onSelect={handleTestExpirationDropdown}
          id="eventExpirationDays"
        >
          {expirationDateDropdownItems}
        </DropdownButton>
        {eventExpirationDays === 1 ? "day" : "days"}
      </div>
    );
  }

  return (
    <div className="mt-2 ml-4">
      Events expire
      <DropdownButton
        className="d-inline-block ml-1 mr-1"
        variant="outline-secondary"
        title={eventExpirationDays || ""}
        onSelect={handleTestExpirationDropdown}
        id="eventExpirationDays"
      >
        {expirationDateDropdownItems}
      </DropdownButton>
      {eventExpirationDays === 1 ? "day" : "days"}{" "}
      {fromSchedulingEventExpiration
        ? "after invitation is sent"
        : "from the start of the event"}
    </div>
  );
};

EventExpirationByDays.propTypes = {
  eventExpirationDays: number,
  handleTestExpirationDropdown: func,
  fromExtendEventExpiration: bool,
  fromSchedulingEventExpiration: bool,
};

export default EventExpirationByDays;
